import { render, staticRenderFns } from "./MobileButtonBottom.vue?vue&type=template&id=46e5cd2a&lang=pug&"
import script from "./MobileButtonBottom.vue?vue&type=script&lang=ts&"
export * from "./MobileButtonBottom.vue?vue&type=script&lang=ts&"
import style0 from "./MobileButtonBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46e5cd2a')) {
      api.createRecord('46e5cd2a', component.options)
    } else {
      api.reload('46e5cd2a', component.options)
    }
    module.hot.accept("./MobileButtonBottom.vue?vue&type=template&id=46e5cd2a&lang=pug&", function () {
      api.rerender('46e5cd2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/shared/MobileButtonBottom.vue"
export default component.exports